// extracted by mini-css-extract-plugin
export default {"button":"r7rtU","link":"Qk-a9","orderInformation":"R2a5-","orderNumber":"PA5Hb","placedOn":"Po3YA","tickets":"LV3rb","summaryDetails":"zWd3U","actions":"XHWcp"};